import { daoPut } from 'mrf/Dao';
import { useFormDataSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import Button from 'mrf/view/Button';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import PageTitle from 'mrf/view/Title';
import React from 'react';
import { useLocation } from 'react-router';
import Flex from 'mrf/layout/Flex';

export default function ConfirmEmail({ history }) {
    const query = new URLSearchParams(useLocation().search);

    const endpoint = '/api/users/confirmEmail';

    const context = useFormSelector({
        resource: 'confirmEmail',
        blankForm: o => ({ ...o, securityToken: query.get("token") }),
    });

    const data = useFormDataSelector(context);

    const backToRoot = () => {
        history.push('/');
    }

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const ret = await daoPut(endpoint, data);
            window.alert(ret?.message);
            backToRoot();
        } catch (e) {
            window.alert(e?.message);
            if (e === '404') {
                window.alert('Unknown user...');
            }
            if (e === '401') {
                window.alert('Action Unauthorized');
            }
            if (e === '500') {
                window.alert('Internal Server Error');
            }

        }
    }

    return (
        <Flex className='items-center justify-center min-h-container'>
            <Paper as='form' onSubmit={handleSubmit}>
                <PageTitle>Click on the button bellow to confirm your email</PageTitle>
                <Grid gap={4}>
                    <Col size={12}>
                        <Button color='primary' type='submit'>Confirm Email</Button>
                    </Col>
                </Grid>
            </Paper>
        </Flex>
    );
}
